// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zors","col":"styles_col___5W8e"};